import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { INotification, NotificationType } from '../../Types/Notification';
import { setHasApplication, setHasMessage, setHasNotifications } from '../slices/NotificationSlice';
import { AppSettings } from '../../Utils/Settings';
export const notificationApi = createApi({
    reducerPath: 'notificationApi',
    baseQuery: fetchBaseQuery({
        baseUrl: AppSettings.ApiBaseUrl,
        prepareHeaders: async (headers, {getState}) =>{
            headers.set(
                'Authorization',
                `Bearer ${(localStorage.getItem('token') ?? '')}`
            );
            return headers;
        }
    }),
    tagTypes: ['Notifications'],
    endpoints: (builder) => ({     
        getNotifications: builder.query<INotification[], string>({
            providesTags: ['Notifications'],
            query: (locator) => ({
                url: `/notification/${locator}`,
                method: "GET"
            })
        }),    
        deleteNotifications: builder.mutation<any, {locator: string, body: string[]}>({
            query: ({locator, body}) => ({
                url: `/notification/${locator}`,
                method: "DELETE",
                body
            })
        }),             
    }),
})

export const {
    useGetNotificationsQuery,
    useDeleteNotificationsMutation
} = notificationApi